import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import * as alpsteinssi from './scripts/alpsteinssi';
alpsteinssi.init();

import * as expandSearch from './scripts/expand-search';
expandSearch.init();

import * as leafletMap from './scripts/leaflet';
leafletMap.init();

import * as loadMore from './scripts/load-more';
loadMore.init();